module.exports = __webpack_public_path__ + "media/packs/images/markers/small-pol-36a1bbdb8cb44433b660b87c96e7c7f2.svg";